export default __webpack_public_path__ + "static/media/tennis-ball.fa5255bd.svg";